module.exports = __webpack_public_path__ + "img/моя мастерская 80х95.52276cdf.jpg";